import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.navbar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-navbar',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/layout.navbar/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}`],
})
export class LayoutNavbarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public showCompanyData: boolean = false;
    public showExpert: boolean = false;
    public showMentorWork: boolean = false;
    public showApplicant: boolean = false;
    public applicantCount: number = 0;
    public showFunds: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.checkCompanyDataAccess();
        await this.checkExpertAccess();
        await this.checkMentorWorkAccess();
        await this.checkApplicantAccess();
        await this.checkFundAccess();
    }

    private async checkCompanyDataAccess() {
        try {
            const res = await wiz.call("check_company_data_access");
            if (res.code === 200) {
                this.showCompanyData = res.data.accessible;
            }
        } catch (e) {
            this.showCompanyData = false;
        }
        await this.service.render();
    }

    private async checkExpertAccess() {
        try {
            const res = await wiz.call("check_expert_access");
            if (res.code === 200) {
                this.showExpert = res.data.accessible;
            }
        } catch (e) {
            this.showExpert = false;
        }
        await this.service.render();
    }

    private async checkMentorWorkAccess() {
        try {
            const res = await wiz.call("check_mentor_diagnosis_access");
            if (res.code === 200) {
                this.showMentorWork = res.data.accessible;
            }
        } catch (e) {
            this.showMentorWork = false;
        }
        await this.service.render();
    }

    private async checkApplicantAccess() {
        try {
            const res = await wiz.call("check_applicant_access");
            if (res.code === 200) {
                this.showApplicant = res.data.accessible;
                this.applicantCount = res.data.count || 0;
            }
        } catch (e) {
            this.showApplicant = false;
        }
        await this.service.render();
    }

    private async checkFundAccess() {
        try {
            const res = await wiz.call("check_fund_access");
            if (res.code === 200) {
                this.showFunds = res.data.accessible;
            }
        } catch (e) {
            this.showFunds = false;
        }
        await this.service.render();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.navbar.toggle(true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public hasAuth(roles: string) {
        roles = roles.split(",");
        return roles.includes(this.service.auth.session.membership);
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "inline-flex items-center border-b-2 border-zinc-900 px-1 pt-1 text-sm font-medium text-zinc-900";
        }
        return "inline-flex items-center border-b-2 border-transparent px-1 pt-1 text-sm font-medium text-zinc-500 hover:border-zinc-300 hover:text-zinc-700 transition-colors";
    }

    public activeClassM(link: string) {
        if (this.isActive(link)) {
            return "block border-l-4 border-zinc-900 bg-zinc-50 py-2 pl-3 pr-4 text-base font-medium text-zinc-900";
        }
        return "block border-l-4 border-transparent py-2 pl-3 pr-4 text-base font-medium text-zinc-500 hover:border-zinc-300 hover:bg-zinc-50 hover:text-zinc-700 transition-colors";
    }
}

export default LayoutNavbarComponent;